import { render } from "./menuFW.vue?vue&type=template&id=7fe552d0"
import script from "./menuFW.vue?vue&type=script&lang=js"
export * from "./menuFW.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__